export const STANDARD_TEMPLATE = "standard"
export const DEFAULT_TEMPLATE = STANDARD_TEMPLATE
export const BACKSTITCH22_TEMPLATE = "backstitch22"
export const BASTINGSTITCH23_TEMPLATE = "bastingstitch23"
export const BLANKETSTITCH24_TEMPLATE = "blanketstitch24"
export const BLINDSTITCH25_TEMPLATE = "blindstitch25"
export const BUTTONHOLESTITCH25_TEMPLATE = "buttonholestitch25"
export const CHAINSTITCH25_TEMPLATE = "chainstitch25"
export const BASTINGSTITCH25_TEMPLATE = "bastingstitch25"
